import React from 'react'
import ArrowDownIcon from '@mui/icons-material/ExpandMore'
import ArrowUpIcon from '@mui/icons-material/ExpandLess'

const RecorderOccupation = ({ onClick, disableDown, disableUp }) => (
	<div style={{ top: '-12px', pointerEvents: 'all' }}>
		<ArrowUpIcon
			style={{
				pointerEvents: disableUp ? 'none' : 'all',
				cursor: disableUp ? 'default' : 'pointer',
				fill: disableUp ? '#ccc' : '#9b9b9b',
			}}
			onClick={e => onClick(e, 'up')}
		/>
		<br />
		<ArrowDownIcon
			style={{
				pointerEvents: disableDown ? 'none' : 'all',
				cursor: disableDown ? 'default' : 'pointer',
				fill: disableDown ? '#ccc' : '#9b9b9b',
			}}
			onClick={e => onClick(e, 'down')}
		/>
	</div>
)

export default RecorderOccupation
